import React from 'react'
import { connect, useSelector } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EnvironmentTitle, HeroPanel, DetailTilesContainer, BannerStatusTile, BannerTilesGroup } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'
import { productSectorMappingDetailSelector, productSectorMappingDraftDetailSelector } from 'selectors/productSelectors'
import { showDraftMappingSelector } from 'selectors/globalGridSelectors'

interface SectorMappingHeroPanelProps {
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/admin/sectors/mapping')
}

const SectorMappingHeroPanelComponent: React.FunctionComponent<SectorMappingHeroPanelProps> = props => {
  const { onTearout } = props

  const sectorMappingList = useSelector(productSectorMappingDetailSelector)
  const sectorMappingDraftList = useSelector(productSectorMappingDraftDetailSelector)
  const draftView = useSelector(showDraftMappingSelector)

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'SectorHeroPanel-EnvironmentTitle'}>
          {draftView ? Locale.translate(Translation.TC_HERO_DRAFT_SECTOR_MAPPING) : Locale.translate(Translation.TC_HERO_SECTOR_MAPPING)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile
            title={Locale.translate(Translation.TC_TOTAL)}
            label={draftView ? sectorMappingDraftList.length : sectorMappingList.length}
          />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}

export const SectorMappingHeroPanel = connect(mapStateToProps, mapDispatchToProps)(SectorMappingHeroPanelComponent)
